/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useFormContext } from '@jalik/react-form'
import CustomerInput, { CustomerInputProps } from '../inputs/CustomerInput'
import { parseNumber } from '@jalik/form-parser'
import { Box } from '@mantine/core'
import CustomerInfo from '../customer/CustomerInfo'
import { FormTextFieldProps } from '../../../../client/js/components/form/fields/FormField'

export type CustomerFieldProps = FormTextFieldProps & Partial<CustomerInputProps>

function CustomerField (props: CustomerFieldProps) {
  const { name = 'customerId', ...others } = props

  const { errors, getFieldProps, getValue, handleSetValue } = useFormContext()
  const fieldProps = getFieldProps(name, others)

  return (
    <Box>
      <CustomerInput
        error={errors[name]?.message}
        {...fieldProps}
        name={name}
        onChange={handleSetValue(name, { parse: parseNumber })}
      />
      <CustomerInfo customerId={getValue(name)} />
    </Box>
  )
}

export default CustomerField
